import writeXlsxFile, { Schema } from 'write-excel-file';

export const exportToExcel = async <T extends object>(
    rows: T[],
    schema: Schema<T>,
    fileName: string
): Promise<void> => {
    await writeXlsxFile(rows, { schema, fileName });
};
